<template>
  <div id="loader-pg" class="pg loader-pg">
    <div class="content">
      <div class="col-12 d-flex justify-content-center">
        <img src="./../../assets/img/logo-simples.png" class="logo">
      </div>
      <div class="col-12 mt-2">
        <img src="./../../assets/img/tipografia.png" class="tipografia">
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
